/**
 * 《标注成果授权协议》— signed by 标注专家 / 仲裁专家 / 课程团队 when they
 * accept an invitation (ACCOUNTS.md §2). Short on purpose: it covers who may
 * use the judgments they produce on the platform.
 */
import { BENEFICIARY_NAME, GRANTEES_LABEL, ORG_NAME } from "../../lib/constants";

/** Bump when the wording changes materially; the server stores this version. */
export const WORK_AGREEMENT_VERSION = "v1";

export const WORK_AGREEMENT_TITLE = "标注成果授权协议";

export const WORK_AGREEMENT_AGREE_LABEL = `我已阅读并同意《${WORK_AGREEMENT_TITLE}》`;

export const WORK_AGREEMENT_SUMMARY =
  "你在平台上做出的标注、判断与仲裁结论，授权给项目方用于研究、教学与商业化产品；署名使用匿名专家编号。";

export interface WorkAgreementClause {
  number: string;
  title: string;
  paragraphs: string[];
}

export const WORK_AGREEMENT_CLAUSES: WorkAgreementClause[] = [
  {
    number: "一",
    title: "授权内容",
    paragraphs: [
      `你在本平台上产生的全部逐字判断、句级评分、仲裁裁定、备注以及相关材料（以下统称「标注成果」），其使用权授予 ${ORG_NAME} 及额外受益人 ${BENEFICIARY_NAME}老师（以下合称「${GRANTEES_LABEL}」）。`,
      `本授权为非独占、可转授给${GRANTEES_LABEL}合作的课程团队，用于学术研究、教学，以及面向公众的（可能收费的）产品与服务。`,
    ],
  },
  {
    number: "二",
    title: "署名与匿名",
    paragraphs: [
      "为保证双盲，标注成果在数据集与产品中以匿名专家编号出现，不带你的姓名。",
      `如果${GRANTEES_LABEL}在论文、报告等学术成果中选择致谢或署名，你有权被列名；是否列名由${GRANTEES_LABEL}与你另行商定。`,
    ],
  },
  {
    number: "三",
    title: "报酬",
    paragraphs: [
      "本授权本身不产生额外费用；你的劳务报酬按你与项目方另行约定的方式结算，不因本协议增加或减少。",
    ],
  },
  {
    number: "四",
    title: "专业责任",
    paragraphs: [
      "你承诺独立作出判断，不与其他专家串通，不把平台上看到的录音、素材或标注内容对外传播。",
      "如果本协议的内容有实质修改，我们会请你重新签署一次。",
    ],
  },
];
